module.exports = __webpack_public_path__ + "img/w2.06066fd2.svg";